module.exports = __webpack_public_path__ + "static/media/Nunito-SemiBold.76ae20d4.ttf";